<template>
	<div class="register-wrapper">
		<header class="header" ref="header">
			<ArrowLeft class="fold" style="width: 2em; height: 2em;" @click="backHome"></ArrowLeft>
			<span class="title"></span>
		</header>
		<div class="mincontent">
			<div class="allContent">
				<iframe  class="network_show" name="content_frame" :src="globalImgPath + '/docs/aboutUs.html'"  frameborder=0
					scrolling="no"></iframe>
					
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getCurrentInstance,
	} from "vue";
	const uniHttp = getCurrentInstance().appContext.config.globalProperties;
	const globalImgPath = uniHttp.globalImgPath; 
	import {
		ArrowLeft
	} from '@element-plus/icons-vue'
	import {
		useRouter
	} from "vue-router";
	const router = useRouter()
	const backHome = () => {
		router.go(-1)
	}
</script>

<style lang="less" scoped>
	.register-wrapper {
		height: 100%;
		width: 100%;
		overflow: hidden;
		background: #fff;
		.header{
			height: 4em;
			line-height: 4em;
			width:100%;
			position: fixed;
			top: 0;
			display: none;
			.fold{
				margin-top: 1em;
				float: left;
				margin-left: 1em;
			}
			span{
				width: calc(100% - 5em);
				font-size: 16px;
				float: left;
				text-align: center;
				overflow: hidden; //超出的文本隐藏
				text-overflow: ellipsis; //溢出用省略号显示
				white-space: nowrap;  // 默认不换行；
			}
		}
		.mincontent {
			position: absolute;
			top: 1em;
			width: calc(100% - 40px);
			margin-left: 20px;
			background: #fff;
			height: calc(100% - 2em);
		}

		.allContent {
			width: 90%;
			margin: 0px 5%;
			background: #fff;
			padding-bottom: 1em;
			position: relative;
			height: 100%;
			.network_show {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>
